// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__SCrek","disabled":"FileBtn_disabled__2yfRQ","warn":"FileBtn_warn__7B9NJ","fade":"FileBtn_fade__28nxS"};